import { Route } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ProtectedRoute } from 'ProtectedRoute';

export const ROUTES = {
    CHOOSE_INSTITUTION: { path: '/choose-institution' },
};

export function configureChooseInstitutionRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: ROUTES,
            config: {},
        },
    ];
}

async function getLazyChooseInstitutionComponent(component: 'ChooseInstitutionPage') {
    const components = await import(/* webpackPrefetch: true */ './components/ChooseInstitutionPage');
    const ChooseInstitutionComponent = components[component];
    if (component === 'ChooseInstitutionPage') {
        return {
            Component: () => (
                <ProtectedRoute accessPolicy="hasLearnerAccess">
                    <ChooseInstitutionComponent />
                </ProtectedRoute>
            ),
        };
    }
    return { Component: ChooseInstitutionComponent };
}

export function getChooseInstitutionRoutes() {
    return (
        <Route
            path={ROUTES.CHOOSE_INSTITUTION.path}
            lazy={() => getLazyChooseInstitutionComponent('ChooseInstitutionPage')}
        />
    );
}
